/*******************************************************************************
CLEAR DATA FILTER
Resets the data filter to its empty state.
*******************************************************************************/

export default function clearFilter(itemSelector) {
    const $input = $(`input[data-items="${itemSelector}"]`);

    // Clear the input, remove the clear button, and show all the items
    $input.val('').parents('.data-filter').find('.filter-clear').remove();
    $(itemSelector).removeClass('hide-filter');
    $('.filter-empty').remove();
}
